import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Tooltip from '@material-ui/core/Tooltip';

let modalContainer;
if (document.getElementById('modal-container')) {
  modalContainer = document.getElementById('modal-container');
} else {
  modalContainer = document.createElement('div');
  modalContainer.id = 'modal-container';
  modalContainer.key = 'modal-container';
  document.body.appendChild(modalContainer);
}

class Modal extends React.Component {
  static propTypes = {
    trigger: PropTypes.node.isRequired,
    tooltipTitle: PropTypes.string,
    render: PropTypes.func,
    onTriggerClick: PropTypes.func,
    onClose: PropTypes.func,
    disablePadding: PropTypes.bool,
    passiveModal: PropTypes.bool,
    modalStyle: PropTypes.object,
  };

  static defaultProps = {
    tooltipTitle: '',
    render: () => null,
    onTriggerClick: () => {},
    onClose: () => {},
    disablePadding: false,
    passiveModal: false,
    modalStyle: {},
  };

  state = {
    modalOpened: false,
  };

  handleModalOpened = () => {
    this.setState({ modalOpened: true });
  };

  handleModalClose = () => {
    this.setState({ modalOpened: false }, () => {
      this.props.onClose();
    });
  };

  render() {
    const {
      trigger,
      render,
      onTriggerClick,
      passiveModal,
      tooltipTitle,
      disablePadding,
      modalStyle,
    } = this.props;

    return (
      <div>
        <Tooltip key="trigger-node" title={tooltipTitle} placement="top">
          {React.cloneElement(trigger, {
            onClick: () => {
              onTriggerClick();
              this.handleModalOpened();
            },
            style: {
              cursor: 'pointer',
            },
          })}
        </Tooltip>

        {ReactDOM.createPortal(
          <Dialog
            open={this.state.modalOpened}
            onClose={() => {
              if (!passiveModal) {
                this.handleModalClose();
              }
            }}
            fullWidth
            {...modalStyle}
          >
            {disablePadding ? (
              render({ closeModal: this.handleModalClose })
            ) : (
              <DialogContent>{render({ closeModal: this.handleModalClose })}</DialogContent>
            )}
          </Dialog>,
          modalContainer,
        )}
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js